/**
 * Electrical Standards & Equipment Constants
 * For BS7671 compliance in certification forms
 */

// BS EN Standards for circuit breakers, switches, and protective devices
export const BS_EN_STANDARDS = [
  { value: 'BS EN 60898-1', label: 'BS EN 60898-1 - Circuit-breakers for overcurrent protection for household and similar installations' },
  { value: 'BS EN 61008-1', label: 'BS EN 61008-1 - Residual current operated circuit-breakers without integral overcurrent protection' },
  { value: 'BS EN 61009-1', label: 'BS EN 61009-1 - Residual current operated circuit-breakers with integral overcurrent protection (RCBOs)' },
  { value: 'BS EN 60947-2', label: 'BS EN 60947-2 - Low-voltage switchgear and controlgear - Circuit-breakers' },
  { value: 'BS EN 60947-3', label: 'BS EN 60947-3 - Low-voltage switchgear and controlgear - Switches, disconnectors, switch-disconnectors and fuse-combination units' },
  { value: 'BS EN 61439-1', label: 'BS EN 61439-1 - Low-voltage switchgear and controlgear assemblies' },
  { value: 'BS EN 60269-1', label: 'BS EN 60269-1 - Low-voltage fuses - General requirements' },
];

// Voltage ratings (V)
export const VOLTAGE_RATINGS = [
  { value: '230', label: '230V' },
  { value: '400', label: '400V' },
  { value: '690', label: '690V' },
  { value: '1000', label: '1000V' },
  { value: 'other', label: 'Other' },
];

// Rated current values (A)
export const RATED_CURRENT_OPTIONS = [
  { value: '6', label: '6A' },
  { value: '10', label: '10A' },
  { value: '16', label: '16A' },
  { value: '20', label: '20A' },
  { value: '25', label: '25A' },
  { value: '32', label: '32A' },
  { value: '40', label: '40A' },
  { value: '50', label: '50A' },
  { value: '63', label: '63A' },
  { value: '80', label: '80A' },
  { value: '100', label: '100A' },
  { value: '125', label: '125A' },
  { value: '160', label: '160A' },
  { value: '200', label: '200A' },
  { value: '250', label: '250A' },
  { value: '315', label: '315A' },
  { value: '400', label: '400A' },
  { value: '500', label: '500A' },
  { value: '630', label: '630A' },
  { value: '800', label: '800A' },
  { value: '1000', label: '1000A' },
];

// RCD ratings (mA)
export const RCD_RATINGS = [
  { value: '10', label: '10mA' },
  { value: '30', label: '30mA' },
  { value: '100', label: '100mA' },
  { value: '300', label: '300mA' },
  { value: '500', label: '500mA' },
];

// SPD types
export const SPD_TYPES = [
  { value: 'TYPE_1', label: 'Type 1 - SPD permanently connected to the electrical installation' },
  { value: 'TYPE_2', label: 'Type 2 - SPD permanently connected to the electrical installation' },
  { value: 'TYPE_3', label: 'Type 3 - SPD permanently connected to the electrical installation' },
  { value: 'NONE', label: 'None' },
];

// Number of phases
export const NUM_PHASES = [
  { value: '1', label: '1 Phase' },
  { value: '3', label: '3 Phase' },
];

// Confirm/Test result options
export const CONFIRM_OPTIONS = [
  { value: 'YES', label: 'YES' },
  { value: 'NO', label: 'NO' },
  { value: 'LIM', label: 'LIM' },
  { value: 'N/A', label: 'N/A' },
];

// Test result options
export const TEST_RESULT_OPTIONS = [
  { value: 'PASS', label: 'PASS' },
  { value: 'FAIL', label: 'FAIL' },
  { value: 'LIM', label: 'LIM' },
  { value: 'N/A', label: 'N/A' },
];

// Equipment serial/model number options (example manufacturers)
export const EQUIPMENT_OPTIONS = [
  { value: 'MFT-3000', label: 'MFT-3000' },
  { value: 'MFT-5000', label: 'MFT-5000' },
  { value: 'MFT-6000', label: 'MFT-6000' },
  { value: 'MFT-7000', label: 'MFT-7000' },
  { value: 'MFT-X1', label: 'MFT-X1' },
];

// Engineer names (placeholder - could be populated from user database)
export const ENGINEER_OPTIONS = [
  { value: 'john_smith', label: 'John Smith' },
  { value: 'jane_doe', label: 'Jane Doe' },
  { value: 'bob_jones', label: 'Bob Jones' },
];

